export class OfferInsuree {
    constructor(
        public Firstname?: String,
        public Lastname?: String,
        public JMBG?: String,
        public DOB?: String,
        public Mobile?: String,
        public Email?: String,
        public Address?: String,
        public Settlement?: String,
        public PostalCode?: String,
        public Occupation?: String,
        public PhonebookID?: Number,
        public ContractorID?: Number,
        public ID?: Number) { }
}